import { render, staticRenderFns } from "./release_block_details.vue.js?vue&type=template&id=57de98c4&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./release_block_details.vue?vue&type=template&id=57de98c4&vue3"
import script from "./release_block_details.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./release_block_details.vue?vue&type=script&lang=js&vue3"
export * from "./release_block_details.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./release_block_details.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports